import React, { useState, useEffect, useContext } from 'react';
import './Additems.css';
import uploadIcon from '../../assets/frontend_assets/upload_icon.png';
import { UrlContext } from '../../Context/UrlContext';

function Additems() {


  const { apiBaseUrl } = useContext(UrlContext);


  const [formData, setFormData] = useState({
    image: null,
    productName: '',
    description: '',
    productType: '',
    categoryName: '',
    price: '',
    deliveryPrice: '',
    sizes: [],
    stockCount: ''
  });

  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [submitStatus, setSubmitStatus] = useState('');
  const [isNewCategory, setIsNewCategory] = useState(false);
  const [manualSizes, setManualSizes] = useState(['']);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${apiBaseUrl}/categories`);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.image) newErrors.image = 'Image required';
    if (!formData.productName.trim()) newErrors.productName = 'Required';
    if (!formData.description.trim()) newErrors.description = 'Required';
    if (!formData.productType) newErrors.productType = 'Required';
    if (!formData.categoryName.trim()) newErrors.categoryName = 'Required';

    const price = parseFloat(formData.price);
    const deliveryPrice = parseFloat(formData.deliveryPrice);
    const stock = parseInt(formData.stockCount);

   if (
  isNaN(price) ||
  price < 0 ||
  price % 1 !== 0 ||
  price.toString().length > 8
) {
  newErrors.price = 'Invalid price (must be a positive integer with up to 8 digits)';
}

if (
  isNaN(deliveryPrice) ||
  deliveryPrice < 0 ||
  deliveryPrice % 1 !== 0 ||
  deliveryPrice.toString().length > 8
) {
  newErrors.deliveryPrice = 'Invalid delivery price (must be a positive integer with up to 8 digits)';
}
if (
  isNaN(stock) ||
  stock <= 0 ||
  stock % 1 !== 0 ||
  stock.toString().length > 3
) {
  newErrors.stock = 'Invalid stock count (must be a positive integer up to 3 digits)';
}




    const manualSizesFiltered = manualSizes.map(s => s.trim()).filter(Boolean);
    const allSizes = [...formData.sizes, ...manualSizesFiltered];
    if (allSizes.length === 0) newErrors.sizes = 'At least one size required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 5000000) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
        setFormData({ ...formData, image: reader.result });
      };
      reader.readAsDataURL(file);
    } else {
      setErrors({ ...errors, image: 'Image must be under 5MB' });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const handleSizeChange = (size) => {
    setFormData(prev => {
      const updatedSizes = prev.sizes.includes(size)
        ? prev.sizes.filter(s => s !== size)
        : [...prev.sizes, size];
      return { ...prev, sizes: updatedSizes };
    });
  };

  const handleManualSizeChange = (i, val) => {
    const newSizes = [...manualSizes];
    newSizes[i] = val;
    setManualSizes(newSizes);
  };

  const addManualSize = () => setManualSizes([...manualSizes, '']);
  const removeManualSize = i => setManualSizes(manualSizes.filter((_, idx) => idx !== i));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setSubmitStatus('submitting');

    const manualSizesFiltered = manualSizes.map(s => s.trim()).filter(Boolean);
    const allSizes = [...formData.sizes, ...manualSizesFiltered];

    try {
      const res = await fetch(`${apiBaseUrl}/products`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, sizes: allSizes })
      });
      if (!res.ok) throw new Error('Failed to add product');
      setSubmitStatus('success');
      setTimeout(() => {
        setFormData({ image: null, productName: '', description: '', productType: '', categoryName: '', price: '', deliveryPrice: '', sizes: [], stockCount: '' });
        setImagePreview(null);
        setManualSizes(['']);
        setIsNewCategory(false);
        setSubmitStatus('');
      }, 1500);
    } catch (err) {
      setSubmitStatus('error');
      setErrors({ submit: 'Error adding product' });
    }
  };



  return (
    <div className="form-container">
      <form onSubmit={handleSubmit} className="product-form">
        <h2>Add New Product</h2>

        <div className="form-group">
          <label>Upload Image</label>
          <div className="image-upload">
            {imagePreview ? (
              <div className="image-preview">
                <img src={imagePreview} alt="Preview" />
                <button type="button" onClick={() => { setImagePreview(null); setFormData({ ...formData, image: null }); }}>Remove</button>
              </div>
            ) : (
              <label className="upload-label">
                <img src={uploadIcon} alt="Upload Icon" />
                <input type="file" accept="image/*" onChange={handleImageChange} hidden />
              </label>
            )}
          </div>
          {errors.image && <p className="error">{errors.image}</p>}
        </div>

        <div className="form-group">
          <label>Product Name</label>
          <input type="text" name="productName" maxLength={40} value={formData.productName} onChange={handleInputChange} />
          {errors.productName && <p className="error">{errors.productName}</p>}
        </div>

        <div className="form-group">
          <label>Description</label>
          <textarea name="description" maxLength={400} value={formData.description} onChange={handleInputChange} />
          {errors.description && <p className="error">{errors.description}</p>}
        </div>

        <div className="form-group">
          <label>Product Type</label>
          <select name="productType" value={formData.productType} onChange={handleInputChange}>
            <option value="">Select</option>
            <option value="men">Men</option>
            <option value="female">Female</option>
            <option value="kid">Kids</option>
          </select>
          {errors.productType && <p className="error">{errors.productType}</p>}
        </div>

        <div className="form-group">
          <label>Category</label>
          {!isNewCategory ? (
            <>
              <select name="categoryName" value={formData.categoryName} onChange={handleInputChange}>
                <option value="">Select</option>
                {categories.map(cat => (
                  <option key={cat.category_id} value={cat.category_name}>{cat.category_name}</option>
                ))}
              </select>
              <button type="button" onClick={() => setIsNewCategory(true)}>New</button>
            </>
          ) : (
            <>
              <input type="text" name="categoryName" maxLength={30} value={formData.categoryName} onChange={handleInputChange} />
              <button type="button" onClick={() => { setIsNewCategory(false); setFormData(prev => ({ ...prev, categoryName: '' })); }}>Select Existing</button>
            </>
          )}
          {errors.categoryName && <p className="error">{errors.categoryName}</p>}
        </div>

        <div className="form-group">
          <label>Price (LKR)</label>
          <input type="number"  name="price"  value={formData.price} onChange={handleInputChange} />
          {errors.price && <p className="error">{errors.price}</p>}
        </div>

        <div className="form-group">
          <label>Delivery Price (LKR)</label>
          <input type="number"  name="deliveryPrice"   value={formData.deliveryPrice} onChange={handleInputChange} />
          {errors.deliveryPrice && <p className="error">{errors.deliveryPrice}</p>}
        </div>

        <div className="form-group">
          <label>Available Sizes</label>
          <div className="size-options">
            {["S", "M", "L", "XL", "XXL"].map(size => (
              <label key={size}>
                <input type="checkbox" maxLength={10} checked={formData.sizes.includes(size)} onChange={() => handleSizeChange(size)} /> {size}
              </label>
            ))}
          </div>
          {errors.sizes && <p className="error">{errors.sizes}</p>}
        </div>

        <div className="form-group">
          <label>Manual Sizes</label>
          {manualSizes.map((size, i) => (
            <div key={i} className="manual-size-input">
              <input type="text" value={size} maxLength={10} onChange={e => handleManualSizeChange(i, e.target.value)} />
              {manualSizes.length > 1 && (
                <button type="button" onClick={() => removeManualSize(i)}>×</button>
              )}
            </div>
          ))}
          <button type="button" onClick={addManualSize}>+ Add Size</button>
        </div>

        <div className="form-group">
          <label>Stock Count</label>
          <input type="number" name="stockCount" maxLength={4} value={formData.stockCount} onChange={handleInputChange} />
          {errors.stockCount && <p className="error">{errors.stockCount}</p>}
        </div>

        <button type="submit" className="submit-btn">{submitStatus === 'submitting' ? 'Submitting...' : 'Add Product'}</button>
        {errors.submit && <p className="error">{errors.submit}</p>}
      </form>
    </div>
  );
}

export default Additems;
